<template lang="html">
  <div id="cart-page" class="d-flex account-page">
    <div class="container main-box">

      <div class="row">
        <div class="col-12 px-2">
          <h1 class="mb-3 page-title">Mi carrito</h1>
        </div>

        <div class="col-lg px-2 col-menu">
          <div class="white-box">
            <div class="box-menu py-2">
              <!-- <p class="item">
                <router-link class="btn-menu" to="/mis-favoritos"><i class="fas fa-heart"></i> Mis favoritos</router-link>
              </p> -->
              <p class="item">
                <router-link class="btn-menu" to="/cart"><i class="fas fa-shopping-cart"></i> Mi carrito</router-link>
              </p>
              <!-- <p class="item">
                <router-link class="btn-menu" to="/mis-favoritos"><i class="fas fa-heart"></i> Mis favoritos</router-link>
              </p> -->
              <!-- <p class="item">
                <router-link class="btn-menu" to="/historial-de-compras"><i class="fas fa-history"></i> Historial de compras</router-link>
              </p> -->
            </div>
          </div>
        </div>

        <div class="col-lg px-2 col-cart-data">

          <!-- <div class="white-box"> -->
          <b-form class="white-box" @submit.prevent="">

            <!-- Paso 1 (Lista de productos agregados a carrito) -->
            <div class="col-12 pt-3 product-list-table" v-if="$route.params.step !== 'envio' && $route.params.step !== 'pago'">
              <div class="col-12 px-0">
                <h5 @click="$refs.modalSuccess.open();">Productos agregados al carrito</h5>

                <h6 class="mt-4 pb-4 f-w-400 text-warning" v-if="!form.products.length"><i class="far fa-shopping-cart"></i> Ningun producto ha sido agregado al carrito</h6>
              </div>

              <div class="row row-products" v-for="(product, index) in form.products">
                <div class="col col-image">
                  <img :src="product.imageUrl">
                </div>

                <div class="col col-info">
                  <h5 class="txt-name">
                    <router-link target="_blank" :to="'/producto/'+product.id">{{ product.name }}<br>{{ product.model_name }}</router-link>
                  </h5>

                  <div class="row mx-0 align-items-center">
                    <div class="d-flex">
                      <h6 class="txt-sm text-muted">SKU: {{ product.sku }}</h6>
                    </div>
                    <div class="d-flex">
                      <div class="box-color-opt opt-sm">
                        <!-- <a class="color" title="Color x" v-bind:style="{ backgroundColor: '#e63003' }">{{ product.color }}</a> -->
                        <!-- <a class="color" :title="product.color">{{ product.color }}</a>
                        <a class="color" :title="product.size">{{ product.size }}</a> -->
                      </div>
                    </div>
                  </div>
                  <hr class="mt-0 mb-1" />

                  <router-link class="link-sm text-muted" target="_blank" :to="'/producto/'+product.id">Ver producto</router-link> <span class="mx-2">|</span> <a class="link-sm text-danger" @click="removeCart(index)"><i class="far fa-trash-alt"></i> Quitar</a>
                </div>

                <div class="col col-price">
                  <p>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} MXN</p>
                  <p style="text-decoration: line-through;color: #c5c5c5;font-size:13px" v-if="product.discount > 0">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price_org) }} MXN</p>
                </div>
                <div class="col col-num">
                  <b-form-input v-model.number="product.quantity" type="number" min="1" :max="product.stock" placeholder="0" @change="updateCart" />
                </div>
              </div>
              

            </div>
            <!-- paso 1, Fin -->

            <!-- Paso 2 (Envio, Datos del usuario y datos de envío) -->
            <div class="col-12 py-4 px-4 user-data" v-if="$route.params.step == 'envio'">
                <h6>Datos de personales</h6>
                <hr class="c-hr" />

                <div class="custom-input _p">
                    <label class="col-form-label pt-0">Nombre:</label>
                    <p class="txt-simple" v-if="$root.logged">{{ form.user.name }}</p>
                    <b-form-input id="user-name" v-else type="text" v-model="form.user.name" size="sm" required placeholder="Nombre"/>
                </div>

                <div class="custom-input _p">
                    <label class="col-form-label pt-0">Apellidos:</label>
                    <p class="txt-simple" v-if="$root.logged" v-text="form.user.lastname"></p>
                    <b-form-input id="user-lastname" v-else type="text" v-model="form.user.lastname" size="sm" required placeholder="Apellidos"/>
                </div>

                <div class="custom-input _p">
                    <label class="col-form-label pt-0">Correo electrónico:</label>
                    <p class="txt-simple" v-if="$root.logged" v-text="form.user.email"></p>
                    <b-form-input id="user-email" v-else type="text" v-model="form.user.email" size="sm" required placeholder="Correo electrónico"/>
                </div>

                <div class="custom-input _p">
                    <label class="col-form-label pt-0">Teléfono:</label>
                    <p class="txt-simple" v-if="$root.logged" v-text="form.user.phone"></p>
                    <b-form-input id="user-phone" v-else type="text" v-model="form.user.phone" size="sm" required placeholder="Teléfono" maxlength="10"/>
                </div>


                <h6 class="mt-5">Información de envío</h6>
                <hr class="c-hr" />

                <!-- <div class="row mx-0 no-gutters">
                    <div class="col-md-12">
                        <b-form-group class="custom-input" label="Tipo de entrega:" label-for="i-entrega">
                            <v-select v-model="form.shippingMethod" :options="['Enviar a domicilio', 'Recoger en tienda']" placeholder="Tipo de entrega"/>
                        </b-form-group>
                    </div>
                </div> -->

                <div >
                    <div class="row mx-0 no-gutters">
                        <div class="col-md-7 col-lg-6">
                        <b-form-group class="custom-input" label="Calle:" label-for="i-calle">
                            <b-form-input id="i-calle" type="text" v-model="form.user.street" size="sm" placeholder="Calle donde vive" required/>
                        </b-form-group>
                        </div>

                        <div class="col-md pl-md-3">
                        <b-form-group class="custom-input" label="Numero exterior:" label-for="i-num">
                            <b-form-input id="i-num" type="text" v-model="form.user.num_ext" size="sm" required/>
                        </b-form-group>
                        </div>

                        <div class="col-md pl-md-3">
                        <b-form-group class="custom-input" label="Numero interior:" label-for="i-num">
                            <b-form-input id="i-num" type="text" v-model="form.user.num_int" size="sm"/>
                        </b-form-group>
                        </div>
                    </div>

                    <div class="row mx-0 no-gutters">
                        <div class="col-md-8">
                        <b-form-group class="custom-input" label="Colonia:" label-for="i-colonia">
                            <b-form-input id="i-colonia" type="text" v-model="form.user.neighborhood" size="sm" required placeholder="Escriba su colonia" />
                        </b-form-group>
                        </div>

                        <div class="col-md pl-md-3">
                        <b-form-group class="custom-input" label="Código postal:" label-for="i-cp">
                            <b-form-input id="i-cp" type="text" v-model="form.user.zipcode" size="sm" required placeholder="Escriba su código postal" />
                        </b-form-group>
                        </div>
                    </div>


                    <div class="row mx-0 no-gutters">
                        <div class="col-md-6 pr-md-3">
                        <b-form-group class="custom-input" label="Estado:" label-for="i-estado">
                            <v-select v-model="form.user.state_id" :options="states" label="name" index="id" @change="getTowns"/>
                        </b-form-group>
                        </div>

                        <div class="col-md-6">
                        <b-form-group class="custom-input" label="Ciudad:" label-for="i-ciudad">
                            <v-select v-model="form.user.town_id" :options="towns" label="name" index="id"/>
                        </b-form-group>
                        </div>
                    </div>
                </div>

                <div>
                  <b-form-checkbox id="check-invoice" v-model="form.invoice" name="check-invoice"> Requiere factura</b-form-checkbox>
                </div>

                <div v-if="form.invoice == true">

                    <div class="row mx-0 no-gutters">
                      
                       
                        <div class="col-md-6 pr-md-3">
                          <b-form-group class="custom-input" label="Razon social:" label-for="i-business_name_invoice">
                              <b-form-input id="i-business_name_invoice" type="text" v-model="form.invoicedata.business_name_invoice" size="sm" required/>
                          </b-form-group>
                        </div>

                        <div class="col-md-6">
                          <b-form-group class="custom-input" label="RFC:" label-for="i-rfc_invoice">
                              <b-form-input id="i-rfc_invoice" type="text" v-model="form.invoicedata.rfc_invoice" size="sm" required/>
                          </b-form-group>
                        </div>
                    </div>

                    <div class="row mx-0 no-gutters">
                        <div class="col-md-7 col-lg-6">
                        <b-form-group class="custom-input" label="Calle:" label-for="i-calle">
                            <b-form-input id="i-calle" type="text" v-model="form.invoicedata.street_invoice" size="sm" placeholder="Calle donde vive" required/>
                        </b-form-group>
                        </div>

                        <div class="col-md pl-md-3">
                        <b-form-group class="custom-input" label="Numero exterior:" label-for="i-num">
                            <b-form-input id="i-num" type="text" v-model="form.invoicedata.num_ext_invoice" size="sm" required/>
                        </b-form-group>
                        </div>

                        <div class="col-md pl-md-3">
                        <b-form-group class="custom-input" label="Numero interior:" label-for="i-num">
                            <b-form-input id="i-num" type="text" v-model="form.invoicedata.num_int_invoice" size="sm"/>
                        </b-form-group>
                        </div>
                    </div>

                    <div class="row mx-0 no-gutters">
                        <div class="col-md-8">
                        <b-form-group class="custom-input" label="Colonia:" label-for="i-colonia">
                            <b-form-input id="i-colonia" type="text" v-model="form.invoicedata.neighborhood_invoice" size="sm" required placeholder="Escriba su colonia" />
                        </b-form-group>
                        </div>

                        <div class="col-md pl-md-3">
                        <b-form-group class="custom-input" label="Código postal:" label-for="i-cp">
                            <b-form-input id="i-cp" type="text" v-model="form.invoicedata.zipcode_invoice" size="sm" required placeholder="Escriba su código postal" />
                        </b-form-group>
                        </div>

                    </div>


                    <div class="row mx-0 no-gutters">
                        <div class="col-md-6 pr-md-3">
                        <b-form-group class="custom-input" label="Estado:" label-for="i-estado">
                            <v-select v-model="form.invoicedata.state_id_invoice" :options="states" label="name" index="id" @change="getTownsInovice"/>
                        </b-form-group>
                        </div>

                        <div class="col-md-6">
                        <b-form-group class="custom-input" label="Ciudad:" label-for="i-ciudad">
                            <v-select v-model="form.invoicedata.town_id_invoice" :options="townsInvoice" label="name" index="id"/>
                        </b-form-group>
                        </div>
                    </div>
                </div>
                <div>
                  <h6 class="mt-5">¿Tienes algun cupon?</h6>
                  <hr class="c-hr" />
                  <form class="col-12" @submit.prevent="checkCupon()" v-if="!form.cupon.id">


                        <div class="col-4 offset-4 text-center">
                            <b-form-group class="custom-input">
                            <b-form-input type="text" v-model="cuopon_code" size="sm" required placeholder="Escribe aqui tu cupon"/>
                            </b-form-group>
                        </div>

                        <div class="col-12 text-center py-2">
                            <button type="submit" class="btn btn-outline-danger btn-sm">Canjear</button>
                        </div>
                  </form>
                  <div class="col-12 text-center" v-if="form.cupon.id">
                        <label style="color: green">Cupon {{form.cupon.code}} aplicado , descuento del ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(form.discount) }}</label>
                  </div>
                  <hr class="c-hr" />
                  <form class="col-12" @submit.prevent="checkCuponRefer()" v-if="!form.users_id_refer">
                    <p>¿Tienes algun codigo de referido?</p>
                    <div class="col-4 offset-4 text-center">
                        <b-form-group class="custom-input">
                        <b-form-input type="text" v-model="cuopon_code_refer" size="sm" required placeholder="Escribe aqui tu codigo de referido"/>
                        </b-form-group>
                    </div>

                    <div class="col-12 text-center py-2">
                        <button type="submit" class="btn btn-outline-danger btn-sm">Validar</button>
                    </div>
                  </form>
                  <form class="col-12" @submit.prevent="checkCuponRefer()" v-else>
                    <p>Codigo de referido aplicado</p>
                    <div class="col-4 offset-4 text-center">
                        <b-form-group class="custom-input">
                          <b-form-input type="text" v-model="cuopon_code_refer" disabled/>
                        </b-form-group>
                    </div>
                    </form>

                </div>

                <div>
                  <b-form-checkbox id="checkbox-1" v-model="form.terms" name="checkbox-1">Al registrarse ha aceptado nuestros términos y condiciones, sus datos personales se utilizarán para procesar su pedido, respaldar su experiencia en este sitio web y para otros fines descritos en nuestros; <router-link to="/terminos-y-condiciones" style="color: black;"><b>Términos y condiciones</b></router-link></b-form-checkbox>
                </div>

            </div>
            <!-- Paso 2, fin  -->

            <!-- Paso 3 (pago) -->
            <div class="col-12 py-4 px-4 user-data" v-if="$route.params.step == 'pago'">
              <h6>Información de pago</h6>
              <hr class="c-hr" />

              <div class="custom-input _p">
                <label class="col-form-label pt-0">Seleccione una forma de pago:</label>
              </div>

              <div class="row mb-4 payment-options-container">
                <!-- <div class="col col-box" @click="changePaymentMe('tarjetas')">
                  <div class="box" v-bind:class="{ active: form.tipoPago == 'tarjetas' }">
                    <h6>Tarjeta de crédito o débito</h6>
                    <p class="icons">
                      <i class="fab fa-cc-visa"></i>
                      <i class="fab fa-cc-mastercard"></i>
                    </p>
                  </div>
                </div> -->

                <div class="col col-box" @click="changePaymentMe('BBVA')">
                  <div class="box" v-bind:class="{ active: form.tipoPago == 'BBVA' }">
                    <h6>Deposito o transferencia con</h6>
                    <p class="icons">
                        <img src="public/images/pages/cart/logo_bbva.svg" width="80px">
                    </p>
                  </div>
                </div>

                
                <div class="col col-box" @click="changePaymentMe('ALBO')">
                  <div class="box" v-bind:class="{ active: form.tipoPago == 'ALBO' }">
                    <h6>Transferencia a</h6>
                    <p class="icons">
                      <img src="public/images/pages/cart/logo_albo.svg" width="80px">
                    </p>
                  </div>
                </div>

                <div class="col col-box" @click="changePaymentMe('mercadopago')" v-if="subtotal < 80000">
                  <div class="box" v-bind:class="{ active: form.tipoPago == 'mercadopago' }">
                    <h6>Pago a traves de </h6>
                    <div class="icons">
                      <span>
                        <img src="public/images/shared/mercadopago.svg" style="width: 80%;">
                      </span>
                    </div>
                  </div>
                </div>

                <!-- <div class="col col-box" @click="changePaymentMe('paypal')">
                  <div class="box" v-bind:class="{ active: form.tipoPago == 'paypal' }">
                    <h6>Pago a traves de Paypal</h6>
                    <p class="icons">
                      <i class="fab fa-paypal"></i>
                    </p>
                  </div>
                </div> -->
              </div>

              <!-- Pago 1, con tarjetas -->
              <div class="row mx-0 no-gutters" v-if="form.tipoPago == 'tarjetas'">
                <div class="col-12">
                    <div class="alert alert-primary" role="alert">
                        Sus datos de tarjeta de debito o de credito no son almacenados por nuestro sistema y son procesados de manera segura y encriptada. En cada pago sera necesario agregar nuevamente estos datos.
                    </div>

                    <label class="mt-3">Detalles de tarjeta:</label>
                    <div id="cardElement"></div>
                    <small class="form text text-muted" id="cardErrors" role="alert"></small>
                </div>
              </div>
              <!--  -->

              <!-- Pago 2, con transferencia bancaria -->
              <!-- <div class="col-12 text-center" v-else-if="form.tipoPago == 'BBVA' || form.tipoPago == 'ALBO'">

                <p>
                  Favor de enviarnos el comprobante de pago al siguiente correo: <br />
                  <strong>pay@extractoseum.com</strong>
                </p>
              </div> -->
              <!--  -->

              <!-- Pago 3, con paypal -->
              <div class="col-12 text-center" v-if="form.tipoPago == 'paypal'">
                <p>Depósito por medio de paypal.</p>

                <hr />
                <p>
                  Favor de enviarnos el comprobante de pago al siguiente correo: <br />
                  <strong>pay@extractoseum.com</strong>
                </p>
              </div>
              <div class="col-12 text-center col-mercadopago" v-show="form.tipoPago == 'mercadopago'">

              <p>Pago por medio de Mercadopago.</p><br>
              <div id="brick-checkout"></div>
              </div>
              <!--  -->
            </div>
            <!-- Paso 3, fin -->
          </b-form>

          <div class="row mx-0 py-3 px-lg-0 no-gutters row-total">
            <div class="col-lg-6">
              <router-link class="btn btn-outline-danger btn-sm btn-action" :to="'/cart/' + form.prev" v-if="form.prev != null">Anterior</router-link>
              <router-link class="btn btn-outline-danger btn-sm btn-action" :to="'/cart/' + form.next" v-if="form.next">Siguiente</router-link>
              <!-- <button class="btn btn-danger btn-sm btn-action" v-if="form.paying && form.tipoPago == 'transferencia'" @click="createOrder()" :disabled="order_id">Confirmar pedido</button> -->
              <button class="btn btn-danger btn-sm btn-action" v-if="form.paying && form.tipoPago == 'BBVA' || form.tipoPago == 'ALBO'" @click="pagar()" :disabled="desactivar || order_id">Confirmar pedido</button>
              <button class="btn btn-danger btn-sm btn-action" v-if="form.paying && form.tipoPago == 'tarjetas'" @click="pagar()" :disabled="desactivar || order_id || form.payment_intent_id">Pagar</button>
              <!-- <button class="btn btn-danger btn-sm btn-action" v-if="form.paying && form.tipoPago == 'mercadopago'" @click="payMercado()" :disabled="desactivar || order_id || form.payment_intent_id">Pagar</button>
             -->
              </div>

            <div class="col-lg-6 text-right">
              <h6><span>Subtotal: </span> ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(subtotal) }}</h6>
              <h6 v-if="form.envio > 0"><span>Envío: </span> ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(form.envio) }}</h6>
              <h6 v-else-if="form.envio == 0"><span>Envío: </span> Gratis</h6>
              <!-- <h6><span>Tiempo de entrega:</span> Entrega de 48 a 72 hrs.</h6> -->
              <h6 v-if="form.discount > 0 "><span>Descuento: </span> ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(form.discount) }}</h6>
              <h5><span>Total: </span> ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(total) }}</h5>
            </div>
          </div>

          <div class="row mx-0 py-3 px-lg-0 no-gutters row-total" v-if="$route.params.step !== 'envio' && $route.params.step !== 'pago'" >
            <div class="col-lg-12" v-if="subtotal < 1000">
                <p>Envío GRATIS en pedidos superiores a: <b>MXN $999.00</b></p>
                <div class="progress" style="width: 60%;background-color: #b7b7b7">
                  <div class="progress-bar bg-success" role="progressbar" :style="{ width: shipfreepercent + '%' }" :aria-valuenow="shipfreepercent" aria-valuemin="0" aria-valuemax="100"></div>
                </div>

                <p>!Añade <b>MXN ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(shipfree) }}</b> mas en productos para envío <b>GRATIS</b></p>
            </div>
          </div>
        </div>

      </div>

      <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
        <div class="fa-3x" v-if="modal.block == true"><i class="fas fa-spinner fa-pulse"></i></div><br/>
        <div v-html="modal.msg"></div>
        <div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
          <div class="txt-description" v-if="stock < 1">Entrega de 48 a 72 hrs</div>
          <b-button class="btn btn-success" slot="button" @click="toHome">Regresar a Home <i class="color-white fas fa-home"></i></b-button>
        </div>
      </sweet-modal>

      <sweet-modal icon="success" :blocking="true" :hide-close-button="true"  ref="modalSuccess">

          <p>TU PEDIDO HA SIDO EXITOSO!</p><br>

          <div v-if="form.tipoPago == 'BBVA'">
            <p><img src="public/images/pages/cart/logo_bbva.svg" width="80px"></p>
            <p><b>Número de pedido:</b> EUM000{{ order_id}}</p>
            <p><b>Banco:</b> {{depositinfo.banco}}</p>
            <p><b>Titular:</b> {{depositinfo.titular}}</p>
            <p><b>CLABE:</b> {{depositinfo.clabe}}</p>
            <p><b>Numero de cuenta:</b> {{depositinfo.numero_cuenta}}</p>
          </div>
          <div v-else-if="form.tipoPago == 'ALBO'">
            <p><img src="public/images/pages/cart/logo_albo.svg" width="80px"></p>
            <p><b>Número de pedido:</b> EUM000{{ order_id}}</p>
            <p><b>Banco:</b> {{depositinfo.banco_albo}}</p>
            <p><b>Titular:</b> {{depositinfo.titular_albo}}</p>
            <p><b>CLABE:</b> {{depositinfo.clabe_albo}}</p>
            <p><b>Numero de cuenta:</b> {{depositinfo.numero_cuenta_albo}}</p>
          </div>
          
          <br><br>
          
          <p>Por favor enviar su comprobante de pago a <b>pay@extractoseum.com</b><br>
            <a class="btn btn-info btn-sm" target="_blank" href="https://wa.me/525519253043"><i class="fab fa-whatsapp"></i> Whatsapp</a>
          </p>
          <br>
          <div class="col-12 text-center" style="padding-top: 20px;" >
            <b-button class="btn btn-success" slot="button" @click="toHome">Regresar a Home <i class="color-white fas fa-home"></i></b-button>
            <b-button class="btn btn-primary" slot="button" @click="toHistorty()">Ir a mis compras <i class="color-white fas fa-clipboard-list"></i></b-button>
          </div>
      </sweet-modal>


    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      form: {
        products: [
        ],

        user: {
          email:null,
          name:null,
          lastname:null,
          phone:null,
          street:null,
          num_ext:null,
          num_int:null,
          neighborhood:null,
          zipcode: null,
          state_id: null,
          town_id: null
        },
        invoicedata:{},

        prev: '',
        next: '',
        paying: false,

        tipoPago: '',
        subtotal: 0,
        total: 0,
        comission:0,
        envio: 0,
        shippingMethod: 'Enviar a domicilio',
        discount:0,
        cupon:{
            name:null,
            id:null,
            amount:null,
            type:null,
            discount_coupon:0
        },
        terms:false,
        users_id_refer:null,
        invoice:false,
      },
      cuopon_code:null,
      modal:{
        msg:'',
        icon:'',
        block:false,
      },

      userLogin: false,
      states: [],
      towns: [],
      townsInvoice:[],
      order_id: null,
      paqueteria: 0,

      stripe: {},
      elements: {},
      cardElement: {},

      desactivar: false,
      depositinfo:{
        banco:null,
        titular:null,
        clabe:null,
    		numero_cuenta:null
      },
      cuopon_code_refer:null,
      shipfree:0,
      shipfreepercent:0,
      order_id:null,
      preferenceId:null,
    }
  },

  computed: {
    subtotal() {
      this.shipfree = 0;
      var subtotal = this.form.products.reduce(function (sum, item) {
          return sum +  (item.price * item.quantity)
        },0);

        var discount = 0;
        if(this.form.cupon.id != null){
            if(this.form.cupon.type == 'Porcentaje %'){
              discount = parseFloat(parseFloat( subtotal * (this.form.cupon.quantity / 100)));

            }
            else if(this.form.cupon.type == 'Cantidad $'){
                discount = parseFloat(this.form.cupon.quantity);
            }
        }
        else{
         
            if(this.$root.logged == true){
              if(this.$root.user.dropshipping == 1){
                  discount = parseFloat(parseFloat( subtotal * (25 / 100)));
                  console.log(discount);
              }
            }
            
        }

        this.form.subtotal = subtotal;

        this.shipfree = 1000 - this.form.subtotal;

        this.shipfreepercent = this.form.subtotal / 10;
        this.form.discount = discount;

        var grandTotal  = parseFloat(subtotal) + parseFloat(this.form.envio) - parseFloat(discount);
        this.form.total = grandTotal;
        
        return this.form.subtotal;
    },

    total() {
      var subtotal = this.form.products.reduce(function (sum, item) {
          return sum +  (item.price * item.quantity)
        },0);

        var discount = 0;
        if(this.form.cupon.id != null){
            if(this.form.cupon.type == 'Porcentaje %'){
                discount = parseFloat(parseFloat( subtotal * (this.form.cupon.quantity / 100)));

            }
            else if(this.form.cupon.type == 'Cantidad $'){
                discount = parseFloat(this.form.cupon.quantity);
            }
        }
        else{
       
            if(this.$root.logged == true){
              if(this.$root.user.dropshipping == 1){
                  discount = parseFloat(parseFloat( subtotal * (25 / 100)));
                  
              }
            }
            
        }


        this.form.subtotal = subtotal;
        this.form.discount = discount;

        var grandTotal  = parseFloat(subtotal) + parseFloat(this.form.envio) - parseFloat(discount);
        this.form.total = grandTotal;
       
        return this.form.total = grandTotal;
    },
    
  },

  methods: {
    changePaymentMe(tipo){
      this.form.tipoPago = tipo;
      if(tipo == "mercadopago"){
        this.modal.block = true;
        this.modal.msg = 'Cargando espere por favor ...';
        this.modal.icon = '';
        this.$refs.modal.open();
          this.loadMercadopago();
          //this.setLoadedMercadopago();
      }
    },

    pagar(){
      if(this.form.tipoPago == 'BBVA' || this.form.tipoPago == 'ALBO'){
        
        this.desactivar = true;
        this.createOrder();
      }

      if(this.form.tipoPago == "tarjetas"){
        this.desactivar = true;
        this.payStripe();
      }
    },

    getSteps(){
      var step = this.$route.params.step;
      this.form.paying = false;

      if(step == 'pago'){ // Paso 3

        if(this.form.user.name == null){
          this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

            this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'El campo "Nombre" es obligatorio';
            this.$refs.modal.open();
            return;
        }
        if(this.form.user.lastname == null){
          this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

           this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'El campo "Apellidos" es obligatorio';
            this.$refs.modal.open();
            return;
        }
        if(this.form.user.email == null){
          this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

           this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'El campo "Email" es obligatorio';
            this.$refs.modal.open();
            return;
        }
        if(this.form.user.phone == null){
          this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

           this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'El campo "Teléfono" es obligatorio';
            this.$refs.modal.open();
            return;
        }
        if(this.form.user.street == null){
          this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

           this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'El campo "Calle" es obligatorio';
            this.$refs.modal.open();
            return;
        }
        if(this.form.user.num_ext == null){
          this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

           this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'El campo "Numero exterior" es obligatorio';
            this.$refs.modal.open();
            return;
        }
        if(this.form.user.neighborhood == null){
            this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

           this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'El campo "Colonia" es obligatorio';
            this.$refs.modal.open();
            return;
        }
        if(this.form.user.zipcode == null){
            this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

           this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'El campo "Código postal" es obligatorio';
            this.$refs.modal.open();
            return;
        }
        if(this.form.user.state_id == null){
            this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

           this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'El campo "Estado" es obligatorio';
            this.$refs.modal.open();
            return;

            
        }
        if(this.form.user.town_id == null){
          this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

           this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'El campo "Ciudad" es obligatorio';
            this.$refs.modal.open();
            return;
        }
        if(this.form.terms == false){
          this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

           this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'Debes aceptar los Términos y condiciones';
            this.$refs.modal.open();
            return;
        }


        


        if(this.form.shippingMethod == 'enviar a domicilio'){
            this.getDistance();
        }

        this.form.prev = 'envio';
        this.form.next = null;
        this.form.paying = true;
      }
      else if(step == 'envio'){ // Paso 2
        this.form.prev = '';
        this.form.next = 'pago';
      }
      else{ // Paso 1
        this.form.prev = null;

        if(this.form.products.length){
          this.form.next = 'envio';
        }
      }
    },

    getStates(){
      axios.get(tools.url('/api/states')).then((response)=>{
        this.states = response.data;
      }).catch((error)=>{
         console.log(error);
      });
    },

    getTowns(){
      if(this.form.user.state_id){
        axios.get(tools.url('/api/towns/' + this.form.user.state_id)).then((response)=>{
          this.towns = response.data;
        }).catch((error)=>{
          console.log(error);
        });
      }
    },
    getTownsInovice(){
      if(this.form.invoicedata.state_id_invoice){
        axios.get(tools.url('/api/towns/' + this.form.invoicedata.state_id_invoice)).then((response)=>{
          this.townsInvoice = response.data;
        }).catch((error)=>{
          console.log(error);
        });
      }
    },

    getInfo(){
      this.form.user = {
        //Datos personales
        id: this.$root.user.id,
        name: this.$root.user.nombre,
        lastname: this.$root.user.apellidos,
        email: this.$root.user.email,
        phone: this.$root.user.telefono,
        street:  (this.$root.user.lastorder ? this.$root.user.lastorder.street : null),
        num_ext: (this.$root.user.lastorder ? this.$root.user.lastorder.num_ext : null),
        num_int: (this.$root.user.lastorder ? this.$root.user.lastorder.num_int : null),
        neighborhood: (this.$root.user.lastorder ? this.$root.user.lastorder.neighborhood : null),
        zipcode: (this.$root.user.lastorder ? this.$root.user.lastorder.zipcode : null),
        state_id: (this.$root.user.lastorder ? this.$root.user.lastorder.state_id : null),
        town_id: (this.$root.user.lastorder ? this.$root.user.lastorder.town_id : null),
      };

      this.getTowns();
    },

    getCart: function(){
     
      this.modal.block = true;
      this.modal.msg = 'Cargando ...';
      this.modal.icon = '';
      this.$refs.modal.open();

      var storage = localStorage.getItem('cart');
      if(storage != null){
        var products = JSON.parse(storage);
        axios.post(tools.url('/api/cart'),{ products:products }).then((response)=>{
          this.form.products = response.data.cart;
          this.form.envio = response.data.envio;
          this.getSteps();

          this.modal.block = false;
          this.modal.msg = null;
          this.modal.icon = null;
          this.$refs.modal.close();

        }).catch((error)=>{
          console.log(error);
          this.getSteps();
          this.modal.block = false;
          this.modal.msg = error.response.data;
          this.modal.icon = 'error';
         
        });
      }
      else{
        this.modal.block = false;
          this.modal.msg = null;
          this.modal.icon = null;
          this.$refs.modal.close();
      }
    },

    getDistance: function(){
        axios.post(tools.url('/api/distance'),{ user:this.form.user }).then((response)=>{
            this.form.envio = response.data.price;
            this.paqueteria = response.data.price;
        }).catch((error)=>{
            console.log(error);
        });
    },

    removeCart: function(index) {
        this.$delete(this.form.products, index)
        this.updateCart();
    },

    updateCart(){
        var cart = [];
        this.form.products.forEach(function(val, index, array){
          var info = { id:val.id, quantity: val.quantity, models_id: val.models_id };
          cart.push(info);
        });
        localStorage.setItem("cart",JSON.stringify(cart));
        this.$root.cartCount = cart.length;
        this.getCart();
    },

    createOrder: function(){
        this.modal.block = true;
        this.modal.icon = '';
        this.modal.msg = 'Procesando, por favor espere...';
        this.$refs.modal.open();
        
        var formcomatografiadata = JSON.parse(localStorage.getItem('comatografia'));

        axios.post(tools.url('/api/order/store'),{ order:this.form, products:this.form.products, user:this.form.user, userLogin:this.$root.logged,formcomatografia:formcomatografiadata }).then((response)=>{
            if(response.data.type === "success"){
                this.desactivar = false;
                this.order_id = response.data.order_id;
                localStorage.removeItem('cart');
                this.$root.cartCount = 0;
                //mensaje
                this.modal.block = false;
                this.$refs.modal.close();
              
                this.$refs.modalSuccess.open();
                if(this.$root.logged == false){
                    axios.post(tools.url('/api/login'),{email:response.data.user.email, password:response.data.user.password}).then((response)=>{
                      this.$parent.user = response.data.user;
                      this.$parent.logged = true;
                      this.$root.auth();
                    }).catch((err) => {
                          
                    });
                }

                /*this.modal.icon = "success";
                if(this.form.tipoPago == 'BBVA'){
                  this.modal.msg = "TU PEDIDO HA SIDO EXITOSO!<br/> Número de pedido:<b> EUM000"+response.data.order_id+"</b> <br> <b>Banco:</b> "+this.depositinfo.banco +"<br><b>Titular:</b> "+this.depositinfo.titular +"<br><b>CLABE:</b> "+this.depositinfo.clabe +"<br><b>Numero de cuenta:</b> "+this.depositinfo.numero_cuenta +"<br><br>Por favor de enviar su comprobante de pago a <b>pay@extractoseum.com</b>";
              
                }
                else if(this.form.tipoPago == 'ALBO'){
                  this.modal.msg = "TU PEDIDO HA SIDO EXITOSO!<br/> Número de pedido:<b> EUM000"+response.data.order_id+"</b> <br> <b>Banco:</b> "+this.depositinfo.banco_albo +"<br><b>Titular:</b> "+this.depositinfo.titular_albo +"<br><b>CLABE:</b> "+this.depositinfo.clabe_albo +"<br><b>Numero de cuenta:</b> "+this.depositinfo.numero_cuenta_albo +"<br><br>Por favor de enviar su comprobante de pago a <b>pay@extractoseum.com</b>";
              
                }*/
                

            }else{

              this.desactivar = false;
          
              this.modal.icon="error";
              this.modal.msg = response.data;
              this.modal.block = false;


            }
        }).catch((error)=>{
          this.desactivar = false;
            console.log(error);
            this.modal.icon="error";
            this.modal.msg = "Fallo al realizar el pedido., Verifique su internet y recargue la página";
            this.modal.block = false;
            this.$refs.modal.open();
        });
    },

    loadStripe(){
      //sandbox key
      this.stripe = Stripe('pk_live_51LZfLsKgxTsOar06OpdR9z3Cgco21fRRaZBJFs027A214ryrWVXCLhoVEWYJpsgOWkemo4sDv9Ysa5hGf8be7aYc00FIJOeKnO');
      this.elements = this.stripe.elements({locale: 'es'});
      this.cardElement = this.elements.create('card', {hidePostalCode: true});

      this.cardElement.mount("#cardElement");
      this.cardElement.addEventListener('change', ({ error }) => {
          const displayError = document.getElementById('cardErrors');
          if (error) {
            displayError.textContent = error.message;
          } else {
            displayError.textContent = '';
          }
      });
    },

    payStripe(){
      this.modal.block = true;
      this.modal.icon = '';
      this.modal.msg = 'Validando el metodo de pago. por favor espere...';
      this.$refs.modal.open();

      this.stripe.createPaymentMethod({
          type: 'card',
          card: this.cardElement,
          billing_details: { name: this.form.user.name+' '+this.form.user.lastname, email: this.form.user.email }
        }).then((result)=>{
          if (result.error) {
            alert('Ocurrió un error con su tarjeta');
            this.desactivar = false;
          } else {
            const data  = { payment_method_id: result.paymentMethod.id, total: this.form.total, name: this.form.name, email: this.form.email };
            axios.post(tools.url('/api/stripe/Installments'),data).then((response)=>{
                this.form.payment_intent_id = response.data.intent_id;
                this.pagarStripe();
              });
          }
      });
    },

    pagarStripe: function(){
      this.modal.block = true;
      this.modal.icon = '';
      this.modal.msg = 'Generando su pedido por favor espere...';
      this.$refs.modal.open();

      axios.post(tools.url('/api/stripe/pay'),{  order:this.form, products:this.form.products, user:this.form.user, userLogin:this.$root.logged }).then((response)=>{
          if(response.data.type === "success"){
            this.order_id = response.data.order_id;
            localStorage.removeItem('cart');
            this.$root.cartCount = 0;
            //mensaje
            this.modal.block = false;
            this.modal.icon = "success";
            this.modal.msg = "TU PEDIDO HA SIDO EXITOSO!<br/> Número de pedido: <b>EUM000"+response.data.order_id+"</b>.";



          }else{
            this.modal.icon = "error";
            this.modal.msg = response.data.message;
            this.modal.block = false;
            this.desactivar = false;
          }
      }).catch((error)=>{
        this.$refs.modal.close();
        alert("ERROR: No se pudo realizar el pedido.");
        this.desactivar = false;
      });
    },
    toHome(){
      this.modal.block = false;
      this.$refs.modal.close();
      this.$router.push('/');
    },
    checkCupon(){
        if (this.form.cupons_id == null) {
            axios.post(tools.url('/api/checkCupon'),{cuopon_code:this.cuopon_code}).then((response)=>{
                this.form.cupon = response.data;

                this.modal.icon = 'success';
                this.modal.msg = 'Cupón aplicado correctamente';
                this.$refs.modal.open();
            }).catch((error)=>{
                this.modal.icon = 'error';
                this.modal.msg = error.response.data.msg;
                this.$refs.modal.open();
            });
        }
        else{
            this.modal.icon = 'warnign';
            this.modal.msg = 'Solo se puede utilizar un cupón';
            this.$refs.modal.open();
        }
    },
    checkCuponRefer(){
      if (this.form.users_id_refer == null) {
            axios.post(tools.url('/api/checkCodeRefer'),{cuopon_code:this.cuopon_code_refer}).then((response)=>{
                this.form.users_id_refer = response.data.id;

                this.modal.icon = 'success';
                this.modal.msg = 'Codigo referido encotrado correctamente';
                this.$refs.modal.open();
            }).catch((error)=>{
                this.modal.icon = 'error';
                this.modal.msg = error.response.data.msg;
                this.$refs.modal.open();
            });
        }
        else{
            this.modal.icon = 'warnign';
            this.modal.msg = 'Solo se puede utilizar un codigo';
            this.$refs.modal.open();
        }
    },
    deleteCupon(){
        this.form.cupon_code = null;
        this.form.cupon.name = null;
        this.form.cupon.id = null;
        this.form.cupon.amount = null;
        this.form.cupon.type = null;

    },
    getDepositinfo(){
      axios.get(tools.url('/api/informaciondeposito')).then((response)=>{
        this.depositinfo = response.data;
      }).catch((error)=>{
         console.log(error);
      });
    },
   
    
    toHistorty(){
          this.modal.block = false;
          this.$refs.modal.close();
          this.$router.push('/usuario/pedidos');
          
    },
    async loadMercadopago(){
      var self = this;
      try {
        // Hacemos la solicitud a tu backend para crear la preferencia
        const response = await axios.post('/api/mercadopago/create-preference', {order:this.form, products:this.form.products, user:this.form.user, userLogin:this.$root.logged});

        // Obtener el ID de la preferencia desde la respuesta
        this.preferenceId = response.data.id;

        // Inicializamos el SDK de Mercado Pago
        const mp = new MercadoPago('APP_USR-84b970a1-4b88-460e-a4c0-214b6ff4a2a0', {
          locale: 'es-MX', // O el idioma que prefieras
        });
        
        
        mp.bricks().create("wallet", "brick-checkout", {
          initialization: {
              preferenceId: this.preferenceId,
          }
        }).then(() => {

          self.modal.block = false;
          self.$refs.modal.close();
   
        }).catch((error) => {
          self.modal.block = false;
          self.modal.msg = 'Error la cargar Mercado pago';
          
        });

      } catch (error) {
        self.modal.block = false;
        self.modal.msg = 'Error la cargar Mercado pago.';
        
      }
  },
 
  },
  mounted(){
    if(this.$route.query.preference_id ){
      this.modal.block = true;
        this.modal.msg = 'Cargando espere por favor ...';
        this.modal.icon = '';
        this.$refs.modal.open();
      axios.post(tools.url('/api/mercadopago/check-status'),{preference_id:this.$route.query.preference_id,payment_id:this.$route.query.payment_id,status:this.$route.query.status}).then((response)=>{

          this.order_id = response.data.order_id;
          localStorage.removeItem('cart');
          //mensaje
          this.modal.block = false;
          this.modal.icon = "success";
          this.modal.msg = "TU PEDIDO HA SIDO EXITOSO!<br/> Número de pedido:<b> EUM000"+response.data.order_id+"</b>";
          
      }).catch((error)=>{
          
          this.modal.icon="error";
          this.modal.msg = "Fallo al realizar el pedido. Favor de intentarlo mas tarde";
          this.modal.block = false;
          this.$refs.modal.open();
      });

    }
    else{
      this.getCart();

      var storagedata = sessionStorage.getItem('formCart');
      if(storagedata != null){
        this.form.user = JSON.parse(storagedata);
      }
    }
  },
  beforeMount(){
    if(this.$route.query.preference_id ){
     /* this.modal.block = true;
        this.modal.msg = 'Cargando espere por favor ...';
        this.modal.icon = '';
        this.$refs.modal.open();
      axios.post(tools.url('/api/mercadopago/check-status'),{preference_id:this.$route.query.preference_id,payment_id:this.$route.query.payment_id,status:this.$route.query.status}).then((response)=>{

          this.order_id = response.data.order_id;
          localStorage.removeItem('cart');
          //mensaje
          this.modal.block = false;
          this.modal.icon = "success";
          this.modal.msg = "TU PEDIDO HA SIDO EXITOSO!<br/> Número de pedido:<b> EUM000"+response.data.order_id+"</b>";
          
      }).catch((error)=>{
          
          this.modal.icon="error";
          this.modal.msg = "Fallo al realizar el pedido. Favor de intentarlo mas tarde";
          this.modal.block = false;
          this.$refs.modal.open();
      });*/

    }
    else{
      this.getDepositinfo();
      this.getSteps();
      this.getStates();
      

      if(this.$root.logged){
        this.getInfo();
      }
    }
   


  },

  watch: {
    '$route.params.step': function () {
      this.getSteps();
    },

    "$root.logged": function(v) {
      if(v == true){
        this.getInfo();
      }
    },
    'form.cupon.id':function(){
        var subtotal = this.form.products.reduce(function (sum, item) {
          return sum +  (item.price * item.quantity)
        },0);

        var discount = 0;
        if(this.form.cupon.id != null){
            if(this.form.cupon.type == 'Porcentaje %'){
                discount = parseFloat(parseFloat( subtotal * (this.form.cupon.quantity / 100)));

            }
            else if(this.form.cupon.type == 'Cantidad $'){
                discount = parseFloat(this.form.cupon.quantity);
            }
        }


        this.form.subtotal = subtotal;
        this.form.discount = discount;

        var grandTotal  = parseFloat(subtotal) + parseFloat(this.form.envio) - parseFloat(discount);
        this.form.total = grandTotal;
       
    },
    form: {
     handler(val){
        sessionStorage.setItem('formCart', JSON.stringify(this.form.user));
     },
     deep: true
  }
    
  }
}
</script>

<style>
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

#form-checkout {
      display: flex;
      flex-direction: column;
      max-width: 100%;
    }

    #form-checkout .containermercado {
      height: 36px;
      display: inline-block;
      border: 1px solid rgb(118, 118, 118);
      border-radius: 2px;
      padding: 1px 2px;
    }

</style>
